import React from 'react';
import { Thermometer, Sun, CloudRain } from 'lucide-react';
import { mockHotelData } from './mock';

const Weather = () => {
  const { weather } = mockHotelData;

  return (
    <section id="weather" className="py-20 bg-gradient-to-br from-blue-50 to-cyan-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            Perfect Weather
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {weather.description} during our stay in {weather.location}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Weather Image */}
          <div className="relative">
            <img
              src={weather.weatherImage}
              alt="Beautiful Mediterranean weather"
              className="w-full h-96 object-cover rounded-2xl shadow-xl"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl"></div>
          </div>

          {/* Weather Details */}
          <div className="space-y-8">
            <div className="text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start gap-3 mb-4">
                <Thermometer className="text-orange-500" size={32} />
                <span className="text-3xl font-bold text-gray-800">{weather.averageTemp}</span>
              </div>
              <p className="text-lg text-gray-600 mb-8">Average Temperature</p>
            </div>

            {/* Daily Weather */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {weather.dailyForecast.map((day, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg transition-shadow duration-200"
                >
                  <div className="text-center">
                    <div className="text-2xl mb-2">{day.icon}</div>
                    <div className="font-medium text-sm text-gray-600">{day.date}</div>
                    <div className="font-bold text-lg text-gray-800">{day.temp}</div>
                    <div className="text-xs text-gray-500 mt-1">{day.condition}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-white rounded-xl p-6 shadow-md">
              <h3 className="text-xl font-bold text-gray-800 mb-3">Weather Highlights</h3>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-center gap-2">
                  <Sun className="text-yellow-500" size={18} />
                  <span>8+ hours of sunshine daily</span>
                </li>
                <li className="flex items-center gap-2">
                  <CloudRain className="text-blue-500" size={18} />
                  <span>No rain during our entire stay</span>
                </li>
                <li className="flex items-center gap-2">
                  <Thermometer className="text-orange-500" size={18} />
                  <span>Perfect beach weather every day</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Weather;